import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Paper,
  Grid,
  Divider,
  Button,
  Autocomplete,
  useTheme,
  useMediaQuery,
  Card,
  CardHeader,
  CardContent,
  CardActions,
} from "@mui/material";
import CustomerListContainer from "../../containers/CustomerListContainer/CustomerListContainer";
import { useDispatch } from "react-redux";
import { fetchDevicesConfigs } from "../../../src/Dashboard/ducks/devicesConfigsDuck";
import config from "config";
import { DevicesConfig } from "../../../src/Dashboard/actions/apiActions";

import SensorCard from "./SensorCard";
import { Stack } from "@mui/material";

const AddSensors = ({ selectedSensorSite, fetchSensorsForEdgeUnit, copiedSensor, resetCopiedSensor }) => {
  const [addingSensor, setAddingSensor] = useState(false);

  const handleSetAddingSensor = (value) => {
    setAddingSensor(value);
  };

  useEffect(() => {
    if (copiedSensor) {
      // If there is a copied sensor, set setAddingSensor to true
      setAddingSensor(true);
    }
  }, [copiedSensor]);

  return (
    <>
      <Button
        variant={addingSensor ? "outlined" : "contained"}
        color={addingSensor ? "error" : "primary"}
        sx={{ mb: 2 }}
        onClick={() => setAddingSensor(!addingSensor)}
      >
        {addingSensor ? "Cancel - Stop Adding Sensors" : "Add New Sensor"}
      </Button>
      {addingSensor && (
        <SensorCard
          selectedSensorSite={selectedSensorSite}
          newSensor={true}
          handleSetAddingSensor={handleSetAddingSensor}
          fetchSensorsForEdgeUnit={fetchSensorsForEdgeUnit}
          copiedSensor={copiedSensor}
          resetCopiedSensor={resetCopiedSensor}
        />
      )}
    </>
  );
};

export default AddSensors;
